/**
 * Handles close banners
 * @module closeBanner
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';

export const PLUGIN_NAME = 'closeBanner';

const closeBannerEventHandlers = ($el) => {
  const closeBannerParent = $el.parents('.js-close-parent');

  $el.on('click', function() {
      closeBannerParent.hide();
      $('body').scroll();

      // cls cookie update
      const cookie = $el.data('cookie');

      if(cookie) {
        updateClsCookieObject(cookie, 0);
      }
  });
}

export default function bannerCloseBtn(el) {
  const $el = $(el);
  closeBannerEventHandlers($el);
}

registerJQueryPlugin(PLUGIN_NAME, bannerCloseBtn);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/close-banner.js